/**
 * The privacy note on the sign-in page. Doug's text, verbatim, one export —
 * nothing here is drafted by a session or a model (WP U5.1). Until he
 * supplies the paragraph this is the placeholder the brief names.
 */
export const PRIVACY_NOTE = 'Privacy note to follow.'
